export const initialState = {
  textDescription: null,
}

export const updatePageData = (state, payload) => (
  { textDescription: payload }
)

export const resetPageData = () => initialState
